import { Injectable, Signal } from '@angular/core';
import {
  IChannel357Collection,
  IChannelSpamCollection,
  IChannelUpSaleCollection,
  IChannelsData,
  IChannelsModel
} from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { ChannelsActions, ChannelsSelectors, IChannelsState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class ChannelsStore extends StateAccessService<IChannelsState> {
  readonly state$: Observable<IChannelsState>;

  readonly data$$: Signal<IChannelsData>;
  readonly model$$: Signal<IChannelsModel>;

  readonly channels357Model$$: Signal<IChannel357Collection>;
  readonly spamModel$$: Signal<IChannelSpamCollection>;
  readonly upSaleModel$$: Signal<IChannelUpSaleCollection>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(ChannelsSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(ChannelsSelectors.data);

    this.channels357Model$$ = this.stateFacade.selectSignal$(ChannelsSelectors.channels357Model);
    this.spamModel$$ = this.stateFacade.selectSignal$(ChannelsSelectors.spamModel);
    this.upSaleModel$$ = this.stateFacade.selectSignal$(ChannelsSelectors.upSaleModel);
  }

  dispatchChannelsReset() {
    this.stateFacade.dispatch(ChannelsActions.reset());
  }
  dispatchChannelsLoad() {
    this.stateFacade.dispatch(ChannelsActions.load());
  }
  dispatchChannelsLoadSuccess({ model, data }: { model: IChannelsModel; data: IChannelsData }) {
    this.stateFacade.dispatch(ChannelsActions.loadSuccess({ model, data }));
  }
}
